export const SAT_LINK = 'https://citas.sat.gob.mx/';
export const VIDEO_LINK = 'https://www.youtube.com/embed/_a6hZF7GdfY';
